import ThreeDotsLoading from './ThreeDotsLoading';

export const Button = ({ children, onClick, buttonType, className, disabled=false, error=null, loading=false, loadingFinish=false, ...rest }) => {
    const classes = `button ${buttonType} ${className} ${loading && !loadingFinish ? 'loading' : disabled && !loadingFinish ? 'disabled' : ''} ${error ? 'error' : ''}`;
    return (
        <button className={classes} onClick={onClick} disabled={loadingFinish || loading || disabled} {...rest}>
            {loading ? <ThreeDotsLoading /> : children}
        </button>
    );
};
